import { defineStore } from 'pinia';

export const useFloatingContentStore = defineStore({
    id: 'floatingContent',
    actions: {
        newContentShown(guid) {},
    },
});